import form from "./schemas/form";
import validations from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import {useEffect, useState} from "react";
import axios from "axios";
import {API_URL} from "../../../config";
import {capitalizeFirstLetter} from "../../../helpers/helpers";
import {listRolesService} from "../../../services/roleService";
import {storeUserService} from "../../../services/userService";
import {listLocationsService} from "../../../services/locationService";

const useNewUser = () => {

    const {formId, formField} = form;

    const [isLoading, setIsLoading] = useState(true);

    const [roles, setRoles] = useState([]);
    const [locations, setLocations] = useState([]);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {

        const init = async () => {
            setIsLoading(true);
            await loadRoles();
            await loadLocations();
            setIsLoading(false);
        };

        init();

    }, []);

    const loadRoles = async () => {

        try {

            const response = await listRolesService({
                sort: 'name',
                direction: 'asc',
                active: true
            });

            if(response.data.data.length > 0)
                setRoles([{id: -1, label: "Selecciona una opción"}, ...response.data.data.map(role => ({id: role.id, label: capitalizeFirstLetter(role.name)}))]);

        } catch (error) {

            setSnackbarConfig({
                message: "Ocurrió un error cargando los roles",
                icon: 'cancel',
                title: 'Roles',
                color: 'warning'
            });

            setShow(true);

        }
    };

    const loadLocations = async () => {

        try {

            const response = await listLocationsService({
                sort: 'name',
                direction: 'asc',
                active: true
            });

            if(response.data.data.length > 0)
                setLocations([{id: -1, label: "Selecciona una opción"}, ...response.data.data.map(location => ({id: location.id, label: location.display_name}))]);

        } catch (error) {

            setSnackbarConfig({
                message: "Ocurrió un error cargando las sucursales",
                icon: 'cancel',
                title: 'Sucursales',
                color: 'warning'
            });

            setShow(true);

        }
    };

    const handleSubmit = async (values, actions) => {

        try {

            let data = values;

            if(data.role_id === 1){
                delete data.location_id;
            }

            // Enviar datos a API
            await storeUserService(data);

            actions.resetForm();

            setSnackbarConfig({
                message: 'Usuario registrado exitosamente',
                icon: 'notifications',
                title: 'Usuarios',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Usuarios',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return {
        validations,
        initialValues,
        formId,
        formField,
        isLoading,
        show,
        roles,
        locations,
        snackbarConfig,
        handleSubmit,
        toggleSnackbar
    };
};

export default useNewUser;
